var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"disabled":_vm.isDemoMode,"placeholder":"Search messages"},scopedSlots:_vm._u([{key:"prepend",fn:function(){return [_c('v-icon',[_vm._v(" fas fa-search ")])]},proxy:true}]),model:{value:(_vm.syncModelValue),callback:function ($$v) {_vm.syncModelValue=$$v},expression:"syncModelValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }